import { render, staticRenderFns } from "./FAQDialog.vue?vue&type=template&id=bdc7f482&scoped=true"
import script from "./FAQDialog.vue?vue&type=script&lang=js"
export * from "./FAQDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc7f482",
  null
  
)

export default component.exports